import React, { Component } from 'react';
import services from '../Services';

export class BlogPreview extends Component {
    static displayName = BlogPreview.name;

    constructor(props) {
        super(props);
        this.state = {
            componentId: props.componentId,
            blogPreview: null,
            blogs: [],
            blogConfiguration: null
        };
    }

    componentDidMount() {
        this.getComponentData();
    }

    render() {
        let title;
        let seeAllLink;
        let seeAllText;

        let blogSnippets = [];

        if (this.state.blogPreview != null) {
            let blogPreview = this.state.blogPreview;

            title = blogPreview.title;
            seeAllLink = blogPreview.seeAllLink;
            seeAllText = blogPreview.seeAllText;

            for (var i = 0; i < this.state.blogs.length; i++) {
                let blog = this.state.blogs[i];

                let backImg = (blog.thumbnailImage != null && blog.thumbnailImage != "") ? blog.thumbnailImage :
                    (this.state.blogConfiguration != null && this.state.blogConfiguration.defaultImage != null && this.state.blogConfiguration.defaultImage != "") ? this.state.blogConfiguration.defaultImage : "";
                let timestamp = services.formatDateTime(blog.timestamp, false, true, false, true);
                let title = blog.title;
                let blogUrl = '/blog/' + blog.friendlyUrl;

                let snippet = <a href={blogUrl} className='blog-snippet' alt="blog image and link" style={{ backgroundImage: "url(" + backImg + ")" }}>
                    <div className='snippet-text'>
                        <div className='super-text'>{timestamp}</div>
                        <div className='sub-text'>{title}</div>
                    </div>
                </a>;
                blogSnippets.push(snippet);
            }
        }

        if (seeAllText == undefined || seeAllText == null || seeAllText == "") {
            seeAllText = "See All";
        }

        return (
            <div className='blog-preview-container'>
                <div className='blog-preview-title'>{title}</div>

                <div className='blog-grid'>
                    {blogSnippets}
                </div>

                <div className='blog-preview-see-all'>
                    <a href={seeAllLink}>{seeAllText}</a>
                </div>
            </div>  
        );
    }

    async getComponentData() {
        const response = await fetch('components/GetBlogPreview?componentId=' + this.state.componentId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        const data = await response.json();

        this.setState({
            blogPreview: data.blogPreview,
            blogs: data.blogs,
            blogConfiguration: data.blogConfiguration
        });
    }
}
